import React, { useState, useEffect, useContext, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import TableCell from "@mui/material/TableCell";
import Table from "@mui/material/Table";
import TableRow from "@mui/material/TableRow";
import TablePagination from "@mui/material/TablePagination";
import InfoIcon from "@mui/icons-material/Info";
import Tooltip from "@mui/material/Tooltip";
import Collapse from "@mui/material/Collapse";

import Button from "@mui/material/Button";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Stack from "@mui/material/Stack";
import UiSwitch, {
     UiSwitchList,
} from "../../../_uiComponents/common/form/UiSwitch";
import UiTableBody from "../../../_uiComponents/common/table/UiTableBody";
import UiTableHead from "../../../_uiComponents/common/table/UiTableHead";
import UiTableWrapper from "../../../_uiComponents/common/table/UiTableWrapper";
import {
     UiGridType,
     ApprovedIcon,
     NotApprovedIcon,
} from "../../../_uiComponents/common/DataGridComponents";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import Popover from '@mui/material/Popover';
import { contextApiActions } from "../../../../_redux/_constants";
import { Context } from "../../../../_context/Store";
import { UiAccordian } from "../../../_uiComponents/common/form/UiToggleArea";
import LookUpTableFilterForm from "../forms/FactTableFilterForm";
import { SearchBarWr } from "../../../_uiComponents/common/form/UiInputComponents";
import {
     factTableListRequest,
     factTableDeleteRequest,
     factTableActiveInactiveRequest,
     factTableValueListRequest,
     factTableGetValueRequest,
     factTableSchemaTemplateRequest,
} from "../../../../_redux/_actions";
import { factTableConfig } from "../module.config";
import FactTableRowDetails from "./FactTableRowDetails";
import FactTableRowManagement from "./FactTableRowManagement";
import FactTableManageData from "./FactTableManageData";

function descendingComparator(a, b, orderBy) {
     if (b[orderBy] < a[orderBy]) {
          return -1;
     }
     if (b[orderBy] > a[orderBy]) {
          return 1;
     }
     return 0;
}

function getComparator(order, orderBy) {
     return order === "desc"
          ? (a, b) => descendingComparator(a, b, orderBy)
          : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
     const stabilizedThis = array.map((el, index) => [el, index]);
     stabilizedThis.sort((a, b) => {
          const order = comparator(a[0], b[0]);
          if (order !== 0) {
               return order;
          }
          return a[1] - b[1];
     });
     return stabilizedThis.map((el) => el[0]);
}

export default function FactTableManagement(props) {
     const [page, setPage] = React.useState(1);
     const [rowsPerPage, setRowsPerPage] = React.useState(5);
     const tableRowId = useRef();

     const actionDispatch = useDispatch();
     const navigate = useNavigate();
     const [state, dispatch] = useContext(Context);

     useEffect(() => {
          getFactTableList();
     }, [page, rowsPerPage]);

     const getFactTableList = (data) => {
          actionDispatch(
               factTableListRequest({
                    page: page,
                    pageSize: rowsPerPage,
                    ...data,
               }),
          );
     };

     const handleChangeRowsPerPage = (event) => {
          setRowsPerPage(event.target.value);
          setPage(1);
     };

     const { tableList, totalRecords } = useSelector((state) => {
          return {
               tableList: state.factTable.list.data,
               totalRecords: state.factTable.list.totalRecords,
          };
     });
     
     const deleteFactTable = (id) => {
          dispatch({
               type: contextApiActions.UI_CONFIRMATION_TOGGEL,
               payload: {
                    show: true,
                    okFunction: () =>
                         actionDispatch(
                              factTableDeleteRequest({
                                   id,
                                   page: page,
                                   pageSize: rowsPerPage,
                              }),
                         ),
               },
          });
     };

     const showTableRowInfo = (id) => {
          dispatch({
               type: contextApiActions.UI_MODAL_TOGGEL,
               payload: {
                    show: true,
                    heading: "Fact table details",
                    children: <FactTableRowDetails id={id} />,
               },
          });
     };

     const [order, setOrder] = React.useState("asc");
     const [orderBy, setOrderBy] = React.useState();
     const [open, setOpen] = React.useState(false);
     const [openDataTable, setDataTable] = React.useState(false);
     const [active, setActive] = React.useState();
     const [dataActive, setDataActive] = React.useState();
     const [editModal, setEditModal] = React.useState(false);
     const [character, setCharacter] = React.useState("");
     const [anchorEl, setAnchorEl] = React.useState(null);
     const [inUseValue, setInUserValue] = useState([]);

     const popOverOpen = (event) => {
          setAnchorEl(event.currentTarget);
     };

     const popOverClose = () => {
          setAnchorEl(null);
     };

     const show = Boolean(anchorEl);
     const id = show ? 'simple-popover' : undefined;

     const handleEditShow = () => setEditModal(true);
     const handleCloseEdit = () => setEditModal(false);

     const manageOpen = (clickedIndex, tableId) => {
          if (active === clickedIndex) {
               setActive(null);
               setOpen(true);
               setDataActive(null);
               setDataTable(false);
          } else {
               setActive(clickedIndex);
               setOpen(true);
               setDataActive(null);
               setDataTable(false);
               tableRowId.current = tableId;
               getTableRowValueList();
          }
     };
     const manageData = (clickedIndex, tableId) => {
          if (dataActive === clickedIndex) {
               setDataActive(null);
               setDataTable(true);
               setActive(null);
               setOpen(false);
          } else {
               setDataActive(clickedIndex);
               setDataTable(true);
               setActive(null);
               tableRowId.current = tableId;
               setOpen(false);
          }
     };

     const getTableRowValueList = (searchValue = "") => {
          actionDispatch(
               factTableValueListRequest({
                    page: 1,
                    pageSize: 100,
                    factTableId: tableRowId.current,
                    search: searchValue,
               }),
          );
     };

     //Pagination
     const handleChangePage = (event, newPage) => {
          setPage(newPage + 1);
     };

     //Sorting
     const handleRequestSort = (event, property) => {
          const isAsc = orderBy === property && order === "asc";
          setOrder(isAsc ? "desc" : "asc");
          setOrderBy(property);
     };

     //Empty rows issue set
     // const emptyRows =
     //      page > 1
     //           ? Math.max(0, (1 + page) * rowsPerPage - tableList.length)
     //           : 0;

     // const [newRows, setNewRows] = React.useState(rows);
     // const [subTableData, setSubTableData] = useState(rows);

     //Add row modal
     const [openAddFieldModal, setOpenAddFieldModal] = React.useState(false);
     const subTableModalOpen = () => setOpenAddFieldModal(true);
     const handleClose = () => setOpenAddFieldModal(false);

     //Data sorting
     const sortingRows = React.useMemo(
          () =>
               stableSort(tableList, getComparator(order, orderBy)),
          [order, orderBy, page, rowsPerPage, tableList],
     );
     

     //Drag and drop reorder
     const reorder = (list, startIndex, endIndex) => {
          const result = Array.from(list);
          const [removed] = result.splice(startIndex, 1);
          result.splice(endIndex, 0, removed);
          return result;
     };

     //Switch function
     const handleChangeActiveInactive = (value, id) => {
          actionDispatch(
               factTableActiveInactiveRequest({
                    page: page,
                    pageSize: rowsPerPage,
                    value,
                    id,
               }),
          );

          // let newArr = [...newRows];
          // newArr[index].enable = event.target.checked;
          // setNewRows(newArr);
     };

     const inUserValue = (id) => {
          setInUserValue(sortingRows.filter(row => row.id === id)[0]);
     }

     return (
          <>
               <UiAccordian>
                    <SearchBarWr>
                         <LookUpTableFilterForm
                              getFactTableList={getFactTableList}
                         />
                    </SearchBarWr>
               </UiAccordian>
               <div className="sba-table-main-wr sba-fact-table-grid">
                    <UiTableWrapper>
                         <UiTableHead
                              headings={factTableConfig.list.tableMapper}
                              order={order}
                              orderBy={orderBy}
                              onRequestSort={handleRequestSort}
                         />
                         <UiTableBody>
                              {sortingRows.map((row, index) => (                      
                                   <>
                                        <TableRow
                                             key={row.id}
                                             sx={{
                                                  "&:last-child td, &:last-child th":
                                                       { border: "none" },
                                             }}
                                        >
                                             {factTableConfig.list.tableMapper.map(
                                                  (headCell, index) => {
                                                       if (headCell.isShow) {
                                                            return headCell.type ==
                                                                 "text" ? (
                                                                 <TableCell
                                                                      align={
                                                                           headCell.align
                                                                      }
                                                                 >
                                                                      {headCell.isNormalTest ? (
                                                                           row[
                                                                           headCell
                                                                                .id
                                                                           ]
                                                                      ) : (
                                                                           <strong>
                                                                                {
                                                                                     row[
                                                                                     headCell
                                                                                          .id
                                                                                     ]
                                                                                }
                                                                           </strong>
                                                                      )}
                                                                 </TableCell>
                                                            ) : (
                                                                 <>
                                                                 {headCell.id ==
                                                                           "labels" && (
                                                                                <TableCell align="center">
                                                                                     <div className="sba-label-type-wr">
                                                                                          {row.labels.map(
                                                                                               (
                                                                                                    label,
                                                                                               ) => (
                                                                                                    <UiGridType
                                                                                                         name={
                                                                                                              label
                                                                                                         }
                                                                                                    />
                                                                                               ),
                                                                                          )}
                                                                                     </div>
                                                                                </TableCell>
                                                                           )}

                                                                      {headCell.id ==
                                                                           "inUse" && (
                                                                                <TableCell align="center">
                                                                                     {row.inUse ? (
                                                                                          <>
                                                                                               <IconButton onClick={(e) => {popOverOpen(e); inUserValue(row.id)}}>
                                                                                                    <ApprovedIcon />
                                                                                                    
                                                                                               </IconButton>
                                                                                                    <Popover
                                                                                                         id={id}
                                                                                                         open={show}
                                                                                                         anchorEl={anchorEl}
                                                                                                         onClose={popOverClose}
                                                                                                         anchorOrigin={{
                                                                                                              vertical: 'bottom',
                                                                                                              horizontal: 'left',
                                                                                                         }}
                                                                                                    >
                                                                                                         <ul className="sb-popover-wr">
                                                                                                         {inUseValue?.inUseTables?.map((name, index) => (
                                                                                                              <li key={index}>{name}</li>
                                                                                                    )    )}
                                                                                                         </ul>
                                                                                                    </Popover>
                                                                                          </>
                                                                                     ) : (
                                                                                          <NotApprovedIcon />
                                                                                     )}{" "}
                                                                                </TableCell>
                                                                           )}

                                                                      {headCell.id ==
                                                                           "active" && (
                                                                                <TableCell align="center">
                                                                                     <UiSwitchList
                                                                                          checked={
                                                                                               row.active
                                                                                          }
                                                                                          handleChange={(
                                                                                               event,
                                                                                          ) => {
                                                                                               handleChangeActiveInactive(
                                                                                                    event,
                                                                                                    row.id,
                                                                                               );
                                                                                          }}
                                                                                          name={
                                                                                               row.name
                                                                                          }
                                                                                     />
                                                                                </TableCell>
                                                                           )}

                                                                      {headCell.id ==
                                                                           "label" && (
                                                                                <TableCell align="left">
                                                                                     <Stack
                                                                                          direction="row"
                                                                                          useFlexGap
                                                                                          spacing={
                                                                                               1
                                                                                          }
                                                                                          flexWrap="wrap"
                                                                                     >
                                                                                          {row.labels.map(
                                                                                               (
                                                                                                    label,
                                                                                               ) => (
                                                                                                    <UiGridType
                                                                                                         name={
                                                                                                              label
                                                                                                         }
                                                                                                    />
                                                                                               ),
                                                                                          )}
                                                                                     </Stack>
                                                                                </TableCell>
                                                                           )}
                                                                      {headCell.id ==
                                                                           " " && (
                                                                                <TableCell align="right"></TableCell>
                                                                           )}
                                                                 </>
                                                            );
                                                       } else {
                                                       }
                                                  },
                                             )}

                                             <TableCell align="center">
                                                  <Button
                                                       size="small"
                                                       variant="outlined"
                                                       endIcon={
                                                            active == index &&
                                                                 open ? (
                                                                 <KeyboardArrowUpIcon />
                                                            ) : (
                                                                 <KeyboardArrowDownIcon />
                                                            )
                                                       }
                                                       onClick={() => {
                                                            manageOpen(
                                                                 index,
                                                                 row.id,
                                                            );
                                                       }}
                                                  >
                                                      Schema
                                                  </Button>
                                             </TableCell>
                                             <TableCell align="center">
                                                  <Button
                                                       size="small"
                                                       variant="outlined"
                                                       endIcon={
                                                            dataActive ==
                                                                 index &&
                                                                 openDataTable ? (
                                                                 <KeyboardArrowUpIcon />
                                                            ) : (
                                                                 <KeyboardArrowDownIcon />
                                                            )
                                                       }
                                                       onClick={() => {
                                                            manageData(
                                                                 index,
                                                                 row.id,
                                                            );
                                                       }}
                                                  >
                                                       Data
                                                  </Button>
                                             </TableCell>
                                             {/* <TableCell align="center">
                                                  <Button
                                                       onClick={() => {
                                                            // TODO need to do in proper way with configurations

                                                            const link =
                                                                 document.createElement(
                                                                      "a",
                                                                 );
                                                            link.href =
                                                                 "https://as-sherbet-api-incentive-dev.azurewebsites.net/v1/FactTable/" +
                                                                 row.id +
                                                                 "/SchemaTemplate";
                                                            // link.download =
                                                            //      fileName;
                                                            document.body.appendChild(
                                                                 link,
                                                            );
                                                            link.click();
                                                            document.body.removeChild(
                                                                 link,
                                                            );
                                                       }}
                                                       size="small"
                                                       variant="contained"
                                                  >
                                                       Download Template
                                                  </Button>
                                             </TableCell> */}
                                             <TableCell
                                                  align="right"
                                                  sx={{ width: "110px" }}
                                             >
                                                  <div className="sbt-data-grid__action-bar">
                                                       <InfoIcon
                                                            onClick={() =>
                                                                 showTableRowInfo(
                                                                      row.id,
                                                                 )
                                                            }
                                                            className="sba-grid-info-icon"
                                                       />
                                                       <Tooltip
                                                            title="Edit"
                                                            placement="top"
                                                            arrow
                                                       >
                                                            <IconButton
                                                                 aria-label="Edit"
                                                                 onClick={() =>
                                                                      navigate(
                                                                           "/app/fact-data-manage/edit/" +
                                                                           row.id,
                                                                      )
                                                                 }
                                                                 sx={{
                                                                      ml: 1.5,
                                                                 }}
                                                            >
                                                                 <EditIcon />
                                                            </IconButton>
                                                       </Tooltip>
                                                       <Tooltip
                                                            title="Delete"
                                                            placement="top"
                                                            arrow
                                                       >
                                                            <IconButton
                                                                 onClick={() =>
                                                                      deleteFactTable(
                                                                           row.id,
                                                                      )
                                                                 }
                                                                 aria-label="delete"
                                                                 sx={{
                                                                      ml: 0.5,
                                                                 }}
                                                            >
                                                                 <DeleteIcon color="error" />
                                                            </IconButton>
                                                       </Tooltip>
                                                  </div>
                                             </TableCell>
                                        </TableRow>

                                        <TableRow>
                                             <TableCell
                                                  style={{
                                                       paddingBottom: 0,
                                                       paddingTop: 0,
                                                       border: "none",
                                                       background: "#f9f8f8",
                                                       borderBottom: "none",
                                                  }}
                                                  colSpan={12}
                                             >
                                                  <Collapse
                                                       in={
                                                            active == index &&
                                                            open
                                                       }
                                                       timeout="auto"
                                                       unmountOnExit
                                                  >
                                                       {active == index &&
                                                            open && (
                                                                 <FactTableRowManagement
                                                                      tableId={
                                                                           row.id
                                                                      }
                                                                      getTableRowValueList={
                                                                           getTableRowValueList
                                                                      }
                                                                 />
                                                            )}
                                                  </Collapse>
                                             </TableCell>
                                        </TableRow>
                                        <TableRow>
                                             <TableCell
                                                  style={{
                                                       paddingBottom: 0,
                                                       paddingTop: 0,
                                                       border: "none",
                                                       background: "#f9f8f8",
                                                       borderBottom: "none",
                                                  }}
                                                  colSpan={12}
                                             >
                                                  <Collapse
                                                       in={
                                                            dataActive ==
                                                            index &&
                                                            openDataTable
                                                       }
                                                       timeout="auto"
                                                       unmountOnExit
                                                  >
                                                       {dataActive == index &&
                                                            openDataTable && (
                                                                 <FactTableManageData
                                                                      id={
                                                                           tableRowId.current
                                                                      }
                                                                 />
                                                            )}
                                                  </Collapse>
                                             </TableCell>
                                        </TableRow>
                                   </>
                              ))}
                              {/* {emptyRows > 0 && (
                                   <TableRow
                                        style={{
                                             height: 53 * emptyRows,
                                        }}
                                   >
                                        <TableCell colSpan={6} />
                                   </TableRow>
                              )} */}
                         </UiTableBody>
                    </UiTableWrapper>
               </div>
               <TablePagination
                    rowsPerPageOptions={[5, 10, 15, 20, 25]}
                    component="div"
                    count={totalRecords}
                    rowsPerPage={rowsPerPage}
                    page={page - 1}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
               />
          </>
     );
}
